export const getRemainingTime = (time) => {
  const chosenTime = new Date(time).getTime();
  const currentTime = new Date().getTime();

  if (!time || currentTime >= chosenTime) {
    return 0;
  }

  return chosenTime - currentTime;
};
